export default class Models extends Array {

    constructor(...models) {
        super(...models);
    }

    sortAsc(attribute="created") {
        return this.sort((a, b) => a[attribute] < b[attribute] ? -1 : 1);
    }

    sortDesc(attribute="created") {
        return this.sort((a, b) => a[attribute] > b[attribute] ? -1 : 1);
    }

}